import React, { useState } from "react";
import "./twofa.css";
import TwofaProcessBar from "./TwofaProcessBar";
import Button from "../UIComponents/Button";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar/Sidebar";

const EnableGuide = () => {
  const [activeStep, setActiveStep] = useState(1);
  const navigate = useNavigate();
  const goToTwoScan = () => {
    navigate("/twofa-scan");
  };

  const goBack = () => {
    navigate(-1);
  };
  return (
    <>
      <Navbar />
      <div className="profile-twofa-main-wrapper">
        {/* <Sidebar /> */}
        <TwofaProcessBar activeStep={activeStep} />

        <div className="profile-twofa-main-wrap">
          <div className="twofa-inner-wrapper">
            <div className="twofa-head-main-wrap">
              <img
                onClick={goBack}
                src="./images/icons/back-arrow.png"
                alt="icon"
              />
              <h3> How to Enable </h3>
            </div>
            <div className="authenticator-main-wrapper">
              <div className="authenticator-image-wrap">
                <img src="./images/icons/authenticator-logo.png" alt="icon" />
              </div>

              <div className="authenticator-store-wrap">
                <p> Get it on Appstore & Playstore </p>
                <div className="authenticator-store-icons-wrap">
                  <img src="./images/icons/app-store.png" alt="icon" />
                  <img src="./images/icons/play-store.png" alt="icon" />
                </div>
              </div>
            </div>
          </div>

          <div className="twofa-footer-wrapper">
            <div className="twofa-footer-wrap">
              <p>
                I have saved my secert key in a secure place. This key will
                allow me to regain access to my account if I lose my mobile
                device or cannot use my authenticator app.
              </p>

              <Button onClick={goToTwoScan} label="Proceed" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EnableGuide;
